module.exports = __webpack_public_path__ + "static/sistemas_web-68cfe505d56da67971e3bb8f40f2be36.png";